var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Bitecs, Schema, type, defaultValue, BitecsSchema } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let FrameRateSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "startFrameStamp");
    __publicField(this, "frameRate");
    __publicField(this, "stopFrameStamp");
    __publicField(this, "averageFrameRate");
    __publicField(this, "bodies");
  }
};
__decorateClass([
  type("number"),
  defaultValue(0)
], FrameRateSchema.prototype, "startFrameStamp", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], FrameRateSchema.prototype, "frameRate", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], FrameRateSchema.prototype, "stopFrameStamp", 2);
__decorateClass([
  type("number"),
  defaultValue(60)
], FrameRateSchema.prototype, "averageFrameRate", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], FrameRateSchema.prototype, "bodies", 2);
FrameRateSchema = __decorateClass([
  Component("FrameRate")
], FrameRateSchema);
let FrameSchema = class extends BitecsSchema {
  constructor() {
    super(...arguments);
    __publicField(this, "frame");
  }
};
__decorateClass([
  type("uint32"),
  defaultValue(0)
], FrameSchema.prototype, "frame", 2);
FrameSchema = __decorateClass([
  Bitecs(),
  Component("Frame")
], FrameSchema);
let FrameEndSchema = class extends Schema {
};
FrameEndSchema = __decorateClass([
  Component("FrameEnd")
], FrameEndSchema);
const __vite_glob_0_3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get FrameEndSchema() {
    return FrameEndSchema;
  },
  get FrameRateSchema() {
    return FrameRateSchema;
  },
  get FrameSchema() {
    return FrameSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  FrameRateSchema as F,
  __vite_glob_0_3 as _,
  FrameSchema as a,
  FrameEndSchema as b
};
//# sourceMappingURL=FrameRate-7ce72a03.js.map
